import { AppCard } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { BookOpenText, Database, FileText, Info, Lightbulb, MessageCircleQuestion } from 'lucide-react'

interface ExternalLink {
  name: string
  uri: string
  icon: React.ComponentType<{ className?: string }>
  color: string
}

const externalDocumentLinks: ExternalLink[] = [
  {
    name: 'ガイドライン',
    uri: 'https://shiftinc365.sharepoint.com/:f:/s/msteams_32f884/ErK0It2r_CZFpqBFsu_cu8MBFESSdaK-EBlpHYUpPt0vVg?e=SfY6bX',
    icon: Info,
    color: '#D50000',
  },
  {
    name: 'マニュアル',
    uri: 'https://shiftinc365.sharepoint.com/:f:/s/msteams_32f884/Ep1UbkKAWtJEiPAEV-q0ZpcBo_lVGbeQx056DDfqPvZX0Q?e=9vroe6',
    icon: BookOpenText,
    color: '#FF7043',
  },
  {
    name: '説明会資料',
    uri: 'https://shiftinc365.sharepoint.com/:b:/s/msteams_32f884/EdPCBuH_AURHtnQaS8-MZ7IBNkgPWLQGrW1Z304WMLUyCA?e=BsSa2I',
    icon: FileText,
    color: '#FFCA28',
  },
  {
    name: 'お役立ち資料',
    uri: 'https://shiftinc365.sharepoint.com/:f:/s/msteams_32f884/Eqqkc8uSUTRItGGgG3vfYjMBe1GkTUSuZHQJiGL_RVm2_w?e=Hbu8JX',
    icon: Lightbulb,
    color: '#39C43E',
  },
]

const externalAppLinks: ExternalLink[] = [
  {
    name: 'キャプテンサロンTeams',
    uri: 'https://teams.microsoft.com/l/team/19%3Adfute8aiMGqQbA8qKsVDBzhacJXrgx4qTI-pexo7zos1%40thread.tacv2/conversations?groupId=f604bad4-be3a-46b4-a697-5ce70494c780&tenantId=1aa34c22-0ed5-47cd-aa30-c11bce319d95',
    icon: MessageCircleQuestion,
    color: '#3F51B5',
  },
  {
    name: 'Metabase',
    uri: 'https://metabase.assign.one-shift.net',
    icon: Database,
    color: '#009688',
  },
  {
    name: 'チャットボットに訊く',
    uri: 'https://sss.one-shift.net',
    icon: MessageCircleQuestion,
    color: '#6B7280',
  },
]

function ExternalLinkCard({ link }: { link: ExternalLink }) {
  const Icon = link.icon
  return (
    <AppCard href={link.uri} external asContent={false} className='h-20 w-48 items-center justify-center gap-2 p-4'>
      <span style={{ color: link.color }}>
        <Icon className='h-8 w-8' />
      </span>
      <span className='text-sm font-medium'>{link.name}</span>
    </AppCard>
  )
}

export function SupportLinksSection() {
  return (
    <div className='space-y-6'>
      {/* サポート資料 */}
      <div>
        <h3 className='text-lg font-semibold mb-4'>サポート資料</h3>
        <div className='flex flex-wrap gap-4'>
          {externalDocumentLinks.map((link) => (
            <ExternalLinkCard key={link.name} link={link} />
          ))}
        </div>
      </div>

      {/* サポートアプリ */}
      <div>
        <h3 className='text-lg font-semibold mb-4'>サポートアプリ</h3>
        <div className='flex flex-wrap gap-4'>
          {externalAppLinks.map((link) => (
            <ExternalLinkCard key={link.name} link={link} />
          ))}
        </div>
      </div>
    </div>
  )
}
